import { templateResult } from '@/utils/templates'
import { controlDeviceId } from '@/components/DeviceProperty/model'
import { isLiveProjectPreview } from './shared-view'

const id = value => typeof value === 'string' && /^[A-Za-z0-9_-]{1,64}$/.test(value)
const nodeId = value => typeof value === 'string' && /^[A-Za-z0-9_-]{1,128}$/.test(value)
const states = ['accepted', 'sending', 'succeeded', 'failed', 'unknown']
const sameTarget = (value, scope) => ['projectId', 'pageId', 'componentId', 'deviceId', 'propertyId'].every(key => value[key] === scope[key])

export function deviceControlReadonly (host) {
  return !host || !!(host.menuFlag || host.isTemplateEditing || host.isComponentTemplateEditing || host.isTemplatePreview || (host.isSharedView && !sharedControlCurrent(host)) ||
    (host.obj && host.obj.templatePreview === true) || (host.isPreview && !host.isSharedView && !isLiveProjectPreview(host)))
}

export function sharedControlCurrent (host) {
  return !!(host && host.isSharedView && host.isSharedDataView && host.shareAuthorizationVersion === 2 && host.shareControlAvailable === true &&
    typeof host.sharedControlClient === 'function' && typeof host.sharedDataCurrent === 'function' && host.sharedDataCurrent())
}

export function deviceControlScope (host, componentId, option) {
  if (deviceControlReadonly(host)) throw new Error('仅登录运行、已加载的项目预览或明确授权的分享允许控制；编辑、模板和未授权分享保持只读')
  if (!['string', 'number'].includes(typeof componentId)) throw new Error('控制组件编号不完整')
  const scope = { projectId: host.isSharedView ? host.shareProjectId : host.projectRecord && host.projectRecord.id, pageId: host.activePageId,
    componentId: String(componentId), deviceId: controlDeviceId(option, host.navigationContext || {}), propertyId: option.propertyId }
  if (!id(scope.projectId) || !id(scope.deviceId) || !nodeId(scope.pageId) || !nodeId(scope.componentId) || typeof scope.propertyId !== 'string' || !scope.propertyId || scope.propertyId.length > 128) throw new Error('项目、页面、组件或属性绑定不完整')
  if (host.isSharedView) scope.shared = true
  if (isLiveProjectPreview(host)) {
    const version = host.obj && host.obj.previewControlVersionId
    if (!id(version)) throw new Error('预览草稿版本未就绪，请回到编辑器重新打开预览')
    scope.previewVersionId = version
  }
  return scope
}

export function controlTarget (scope) {
  const target = { pageId: scope.pageId, componentId: scope.componentId, deviceId: scope.deviceId }
  if (scope.previewVersionId) target.previewVersionId = scope.previewVersionId
  return target
}

function controlVersion (value, scope) {
  if (scope.previewVersionId) {
    if (value.controlSource !== 'preview' || value.previewVersionId !== scope.previewVersionId ||
        value.controlVersionId !== scope.previewVersionId || value.publishedVersionId !== '') throw new Error('预览控制版本回执无效，请保存草稿后重新打开预览')
    return value.controlVersionId
  }
  const version = value.controlVersionId === undefined ? value.publishedVersionId : value.controlVersionId
  if (!id(version) || (scope.shared ? value.controlSource !== 'share' : value.controlSource !== undefined && value.controlSource !== 'published') ||
      (value.previewVersionId !== undefined && value.previewVersionId !== null && value.previewVersionId !== '') ||
      (value.publishedVersionId !== undefined && value.publishedVersionId !== version)) throw new Error('正式控制版本回执无效，请重新读取')
  return version
}

export function controlCapability (response, scope) {
  const value = templateResult(response)
  if (!value || !sameTarget(value, scope) || !id(value.productId) ||
      !/^[a-f0-9]{64}$/.test(value.metadataHash) || typeof value.canWrite !== 'boolean' || typeof value.reason !== 'string' ||
      !value.property || value.property.id !== scope.propertyId || typeof value.property.writable !== 'boolean' ||
      (value.canWrite && !value.property.writable)) throw new Error('控制能力回执无效，请重新读取')
  return { ...value, controlVersionId: controlVersion(value, scope) }
}

export function controlCheck (response, scope, capability) {
  const value = templateResult(response)
  if (!value || !sameTarget(value, scope) || value.valid !== true || controlVersion(value, scope) !== capability.controlVersionId || value.metadataHash !== capability.metadataHash) throw new Error('控制内容或物模型已变化，请重新读取控制能力后确认')
  return value
}

export function controlOperation (response, scope, requestId) {
  const value = templateResult(response)
  if (!value || !sameTarget(value, scope) || value.requestId !== requestId || !id(value.operationId) ||
      !states.includes(value.state) || typeof value.confirmedResponse !== 'boolean' || typeof value.replyReceived !== 'boolean' ||
      (value.state === 'succeeded' && (!value.confirmedResponse || !value.replyReceived))) throw new Error('操作回执无效，结果待核实；请查询原请求，不要重复下发')
  return { ...value, controlVersionId: controlVersion(value, scope) }
}

export const pendingControl = operation => !!operation && ['accepted', 'sending'].includes(operation.state)
export const controlStateText = operation => !operation ? '' : ({ accepted: '已受理，等待发送', sending: '正在发送，等待设备回复',
  succeeded: '设备已回复成功', failed: '操作失败', unknown: '执行结果未知，请核实' })[operation.state] || '执行结果待核实'
